import { InjectionToken } from "@angular/core";
import { LangFuseService } from "../services/langfuse.service";
import { EnvironmentType } from "../classes/iqBoost";

export const IQ_BOOST_LANGFUSE = new InjectionToken<LangFuseService>(
  'iqBoost',
);
export const IQ_BOOST_LANGFUSE_SLE = new InjectionToken<LangFuseService>(
  'iqBoostSLE',
);
export const MAXIMIZER_AI_ENVIRONMENT = new InjectionToken<EnvironmentType>(
  'maximizerAiEnvironment',
);
export const INTEGRATION_WEB_APP_URL = new InjectionToken<string>(
  'integrationWebAppUrl',
);
export const INTEGRATION_SUBSCRIPTION_KEY = new InjectionToken<string>(
  'integrationSubscriptionKey',
);
export const INTEGRATION_IQ_BOOST_URL = new InjectionToken<string>(
  'integrationIqBoostUrl',
);
